<template>
  <v-app class="bg-transparent">
    <div ref="formContainer" class="container-fluid pl-0">
      <v-row>
        
        <v-col cols="6">
          <v-row>
          <v-col cols="12" v-show="isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: 725px;
            ">
            <v-col class="color-default font-weight-bold py-5 px-5 mb-1">
              <b-skeleton-img  no-aspect  height="34px" width="40%"  border-radius="5%"></b-skeleton-img>
            </v-col>
            <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead id="support_table_header">
              <tr>
                <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
              </tr>
              </thead>
              <tbody id="table_body">
              <tr  id="table_row" >
                <td colspan="8 ">
                  <b-skeleton-wrapper >
                    <b-skeleton height="40px" ></b-skeleton>
                    <b-skeleton height="40px"></b-skeleton>
                    <b-skeleton height="40px"></b-skeleton>
                  </b-skeleton-wrapper>
                </td>
              </tr>
              </tbody>
            </table>
            <!-- <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table> -->
          </v-card>
        </v-col>
            <v-col cols="12" v-show="!isLoader">
              <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: 725px;
              /*overflow: scroll;*/
            ">
                <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Quick Tasks</v-card-title>
                <quick_task :quickTaskList="dashboard.quickTaskList" :flag="dashboard.flag" :total="dashboard.totalQuickTask"
                            :totalPages="dashboard.totalPageQuickTask" :page="dashboard.pageQuickTask"  :totalRows="dashboard.totalRowsQuickTask" :currentPage="dashboard.currentPageQuickTask" @setPageQuickTask="setPageQuickTask"
                ></quick_task>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row class="mt-1">
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 3 ) && isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="33%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="5"></v-col>
                  <b-skeleton no-aspect height="70px" width="21%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class=" pl-6 py-1 mb-1 mt-0">
                    <b-skeleton-img  no-aspect  height="21px" width="33%"  border-radius="5%"></b-skeleton-img>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 3) && !isLoader">

              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="8">
                    <v-card-subtitle class="cs-color test pl-5 pt-3 pb-0">Total Posts</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{dashboard.posts}}</v-card-text>
                  </v-col>
                  <v-col cols="4" class="mt-2">
                    <v-btn dark fab x-large class="gradient1 elevation-0 ml-3 d-icon" style="cursor: default">
                      <svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.63153 20.2279V1.13232H28.575V20.2279C28.575 21.0447 28.2505 21.8281 27.6729 22.4057C27.0953 22.9833 26.312 23.3078 25.4951 23.3078H4.55161M19.9512 6.06021H23.6472V10.9881H19.9512V6.06021ZM11.3274 15.916H24.8791H11.3274ZM11.3274 10.9881H16.2553H11.3274ZM11.3274 6.06021H16.2553H11.3274ZM7.63153 20.2279C7.63153 21.0447 7.30704 21.8281 6.72944 22.4057C6.15185 22.9833 5.36845 23.3078 4.55161 23.3078C3.73476 23.3078 2.95137 22.9833 2.37377 22.4057C1.79617 21.8281 1.47168 21.0447 1.47168 20.2279V6.06021H7.66233L7.63153 20.2279Z"
                            stroke="white" stroke-width="2" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <a class="cs-color2 pl-3 py-1 mb-1 mt-0 cs-color" href="/posts">
                    View more
                  </a>
                </v-card-actions>
              </v-card>
            </v-col>
            
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 3 ) && isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="33%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="5"></v-col>
                  <b-skeleton no-aspect height="70px" width="21%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class=" pl-6 py-1 mb-1 mt-0">
                    <b-skeleton-img  no-aspect  height="21px" width="33%"  border-radius="5%"></b-skeleton-img>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 3) && !isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="8">
                    <v-card-subtitle class="cs-color pl-5 pt-3 pb-0">Unnotitied Tasks</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{dashboard.tasks}}</v-card-text>
                  </v-col>
                  <v-col cols="4" class="mt-2">
                    <v-btn x-large fab dark class="gradient2 elevation-0 ml-3 d-icon" style="cursor: default">
                      <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.423 20.3374C19.9475 20.3374 22.2103 20.3374 23.6152 18.9313C25.0214 17.5263 25.0214 15.2635 25.0214 10.739C25.0214 6.21458 25.0214 3.95176 23.6152 2.54679C22.2103 1.14062 19.9475 1.14063 15.423 1.14063H10.6238C6.09935 1.14063 3.83652 1.14062 2.43156 2.54679C1.02539 3.95176 1.02539 6.21458 1.02539 10.739C1.02539 15.2635 1.02539 17.5263 2.43156 18.9313C3.21503 19.7159 4.26485 20.0627 5.8246 20.2151"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13.0234 10.7393V10.7514" stroke="white" stroke-width="2" stroke-linecap="round" />
                        <path d="M8.22461 10.7393V10.7514" stroke="white" stroke-width="2" stroke-linecap="round" />
                        <path d="M17.8223 10.7393V10.7514" stroke="white" stroke-width="2" stroke-linecap="round" />
                        <path
                            d="M15.423 20.3373C13.94 20.3373 12.3059 20.9372 10.8145 21.7111C8.41734 22.9553 7.21874 23.578 6.62844 23.1808C6.03813 22.7849 6.14971 21.5551 6.37408 19.0967L6.42447 18.5376"
                            stroke="white" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <a class="cs-color2 pl-3 py-1 mb-1 mt-0" @click="viewMore()" href="/common/development/task?unnotified=1">View more</a>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 4 || role == 10) && isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="33%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="5"></v-col>
                  <b-skeleton no-aspect height="70px" width="21%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class=" pl-6 py-1 mb-1 mt-0">
                    <b-skeleton-img  no-aspect  height="21px" width="33%"  border-radius="5%"></b-skeleton-img>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="6" v-show="(role == 0 || role == 1 || role == 4 || role == 10) && !isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="8">
                    <v-card-subtitle class="card-title cs-color pl-5 pt-3 pb-0 mb-0">Total Users</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.users }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="4" class="mt-2">
                    <v-btn x-large fab dark class="gradient4 elevation-0 ml-3 d-icon" style="cursor: default">
                      <!-- <v-icon size="24px" class="fa fa-users"></v-icon> -->
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.07366 12.7039C4.21531 12.647 4.36764 12.6173 4.52165 12.6168C4.67565 12.6163 4.82821 12.6449 4.97029 12.7009C5.11238 12.7568 5.24111 12.8391 5.34888 12.9428C5.45665 13.0465 5.54127 13.1695 5.59773 13.3045C5.6542 13.4395 5.68136 13.5838 5.67763 13.7289C5.67389 13.874 5.63932 14.0169 5.57597 14.1492C5.51262 14.2815 5.42176 14.4005 5.30878 14.4991C5.1958 14.5977 5.06298 14.674 4.91818 14.7234C4.14802 15.0094 3.48701 15.5072 3.02117 16.152C2.55533 16.7969 2.30622 17.5589 2.30626 18.339V20.2282C2.30626 20.5162 2.42764 20.7924 2.64371 20.996C2.85978 21.1996 3.15284 21.314 3.45841 21.314H12.6756C12.9812 21.314 13.2742 21.1996 13.4903 20.996C13.7064 20.7924 13.8278 20.5162 13.8278 20.2282V18.44C13.8279 17.6349 13.5684 16.8487 13.0836 16.1858C12.5988 15.5228 11.9117 15.0143 11.1133 14.7278C10.9676 14.6801 10.8335 14.6054 10.719 14.508C10.6046 14.4106 10.512 14.2926 10.4468 14.1609C10.3816 14.0291 10.3452 13.8864 10.3396 13.7412C10.3341 13.5959 10.3595 13.4511 10.4144 13.3153C10.4694 13.1795 10.5527 13.0555 10.6594 12.9506C10.7661 12.8457 10.8941 12.762 11.0358 12.7046C11.1775 12.6472 11.33 12.6171 11.4842 12.6163C11.6384 12.6154 11.7912 12.6437 11.9336 12.6996C13.1683 13.1428 14.2309 13.929 14.9807 14.9542C15.7304 15.9793 16.132 17.1949 16.1321 18.44V20.2282C16.1321 21.0921 15.7679 21.9206 15.1197 22.5315C14.4715 23.1423 13.5923 23.4855 12.6756 23.4855H3.45841C2.5417 23.4855 1.66254 23.1423 1.01433 22.5315C0.366114 21.9206 0.00195313 21.0921 0.00195312 20.2282V18.339C0.00211166 17.1231 0.390547 15.9354 1.11673 14.9304C1.84291 13.9254 2.87323 13.1496 4.07366 12.7039ZM8.06701 1.77033C9.28929 1.77033 10.4615 2.2279 11.3258 3.04237C12.1901 3.85685 12.6756 4.96152 12.6756 6.11336V8.28488C12.6756 9.43672 12.1901 10.5414 11.3258 11.3559C10.4615 12.1703 9.28929 12.6279 8.06701 12.6279C6.84473 12.6279 5.67252 12.1703 4.80824 11.3559C3.94396 10.5414 3.45841 9.43672 3.45841 8.28488V6.11336C3.45841 4.96152 3.94396 3.85685 4.80824 3.04237C5.67252 2.2279 6.84473 1.77033 8.06701 1.77033ZM8.06701 3.94185C7.45587 3.94185 6.86976 4.17063 6.43762 4.57787C6.00548 4.98511 5.76271 5.53744 5.76271 6.11336V8.28488C5.76271 8.8608 6.00548 9.41313 6.43762 9.82037C6.86976 10.2276 7.45587 10.4564 8.06701 10.4564C8.67815 10.4564 9.26426 10.2276 9.6964 9.82037C10.1285 9.41313 10.3713 8.8608 10.3713 8.28488V6.11336C10.3713 5.53744 10.1285 4.98511 9.6964 4.57787C9.26426 4.17063 8.67815 3.94185 8.06701 3.94185ZM18.4364 22.3997C18.1308 22.3997 17.8377 22.2853 17.6217 22.0817C17.4056 21.8781 17.2842 21.6019 17.2842 21.314C17.2842 21.026 17.4056 20.7499 17.6217 20.5462C17.8377 20.3426 18.1308 20.2282 18.4364 20.2282H19.5885C19.8941 20.2282 20.1872 20.1138 20.4032 19.9102C20.6193 19.7066 20.7407 19.4304 20.7407 19.1425V17.1468C20.7406 16.375 20.4829 15.6228 20.004 14.9967C19.5251 14.3706 18.8493 13.9024 18.0723 13.6583C17.7823 13.5673 17.5426 13.3715 17.4058 13.1139C17.269 12.8563 17.2464 12.5581 17.343 12.2848C17.4395 12.0115 17.6473 11.7856 17.9207 11.6567C18.194 11.5278 18.5105 11.5065 18.8005 11.5975C20.0365 11.9857 21.1115 12.7305 21.8733 13.7265C22.6351 14.7225 23.045 15.9191 23.045 17.1468V19.1425C23.045 20.0063 22.6808 20.8348 22.0326 21.4457C21.3844 22.0566 20.5052 22.3997 19.5885 22.3997H18.4364ZM14.9799 2.85609C14.6744 2.85609 14.3813 2.7417 14.1652 2.53808C13.9492 2.33446 13.8278 2.05829 13.8278 1.77033C13.8278 1.48237 13.9492 1.2062 14.1652 1.00258C14.3813 0.798962 14.6744 0.68457 14.9799 0.68457C16.2022 0.68457 17.3744 1.14214 18.2387 1.95662C19.103 2.77109 19.5885 3.87576 19.5885 5.0276V7.19912C19.5885 8.35097 19.103 9.45563 18.2387 10.2701C17.3744 11.0846 16.2022 11.5422 14.9799 11.5422C14.6744 11.5422 14.3813 11.4278 14.1652 11.2241C13.9492 11.0205 13.8278 10.7444 13.8278 10.4564C13.8278 10.1684 13.9492 9.89227 14.1652 9.68865C14.3813 9.48503 14.6744 9.37064 14.9799 9.37064C15.5911 9.37064 16.1772 9.14185 16.6093 8.73462C17.0414 8.32738 17.2842 7.77504 17.2842 7.19912V5.0276C17.2842 4.45168 17.0414 3.89935 16.6093 3.49211C16.1772 3.08487 15.5911 2.85609 14.9799 2.85609Z"
                            fill="white" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <a class="cs-color2 pl-3 py-1 mb-1 mt-0" href="/users">View more</a>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="6" v-show="(role == 0 || role == 1) && isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="33%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="5"></v-col>
                  <b-skeleton no-aspect height="70px" width="21%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class=" pl-6 py-1 mb-1 mt-0">
                    <b-skeleton-img  no-aspect  height="21px" width="33%"  border-radius="5%"></b-skeleton-img>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="6" v-show="(role == 0 || role == 1) && !isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="8" class="pr-0">
                    <v-card-subtitle class="cs-color pl-5 pt-3 pb-0">Next Week Schedule</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.next_week }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="4" class="mt-2">
                    <v-btn x-large fab dark class="gradient5 elevation-0 ml-3 d-icon" style="cursor: default">
                      <!-- <v-icon size="24px" class="fa fa-calendar" ></v-icon> -->
                      <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.0232 14.3667C13.2627 14.3667 13.4968 14.2998 13.6959 14.1744C13.895 14.0491 14.0501 13.8709 14.1418 13.6624C14.2334 13.4539 14.2574 13.2245 14.2107 13.0032C14.164 12.7819 14.0486 12.5786 13.8793 12.419C13.71 12.2594 13.4943 12.1508 13.2594 12.1067C13.0246 12.0627 12.7811 12.0853 12.5599 12.1717C12.3387 12.258 12.1496 12.4043 12.0165 12.5919C11.8835 12.7795 11.8125 13.0001 11.8125 13.2258C11.8125 13.5284 11.9401 13.8186 12.1671 14.0325C12.3942 14.2465 12.7021 14.3667 13.0232 14.3667ZM19.0768 14.3667C19.3163 14.3667 19.5504 14.2998 19.7495 14.1744C19.9486 14.0491 20.1037 13.8709 20.1954 13.6624C20.287 13.4539 20.311 13.2245 20.2643 13.0032C20.2176 12.7819 20.1022 12.5786 19.9329 12.419C19.7636 12.2594 19.5479 12.1508 19.313 12.1067C19.0782 12.0627 18.8347 12.0853 18.6135 12.1717C18.3923 12.258 18.2032 12.4043 18.0701 12.5919C17.9371 12.7795 17.8661 13.0001 17.8661 13.2258C17.8661 13.5284 17.9937 13.8186 18.2207 14.0325C18.4478 14.2465 18.7557 14.3667 19.0768 14.3667ZM13.0232 18.9305C13.2627 18.9305 13.4968 18.8636 13.6959 18.7382C13.895 18.6129 14.0501 18.4347 14.1418 18.2262C14.2334 18.0177 14.2574 17.7883 14.2107 17.567C14.164 17.3457 14.0486 17.1424 13.8793 16.9828C13.71 16.8232 13.4943 16.7146 13.2594 16.6705C13.0246 16.6265 12.7811 16.6491 12.5599 16.7355C12.3387 16.8218 12.1496 16.9681 12.0165 17.1557C11.8835 17.3433 11.8125 17.5639 11.8125 17.7896C11.8125 18.0922 11.9401 18.3824 12.1671 18.5963C12.3942 18.8103 12.7021 18.9305 13.0232 18.9305ZM19.0768 18.9305C19.3163 18.9305 19.5504 18.8636 19.7495 18.7382C19.9486 18.6129 20.1037 18.4347 20.1954 18.2262C20.287 18.0177 20.311 17.7883 20.2643 17.567C20.2176 17.3457 20.1022 17.1424 19.9329 16.9828C19.7636 16.8232 19.5479 16.7146 19.313 16.6705C19.0782 16.6265 18.8347 16.6491 18.6135 16.7355C18.3923 16.8218 18.2032 16.9681 18.0701 17.1557C17.9371 17.3433 17.8661 17.5639 17.8661 17.7896C17.8661 18.0922 17.9937 18.3824 18.2207 18.5963C18.4478 18.8103 18.7557 18.9305 19.0768 18.9305ZM6.96961 14.3667C7.20907 14.3667 7.44315 14.2998 7.64225 14.1744C7.84136 14.0491 7.99654 13.8709 8.08817 13.6624C8.17981 13.4539 8.20379 13.2245 8.15707 13.0032C8.11036 12.7819 7.99504 12.5786 7.82572 12.419C7.6564 12.2594 7.44067 12.1508 7.20581 12.1067C6.97096 12.0627 6.72752 12.0853 6.50629 12.1717C6.28506 12.258 6.09597 12.4043 5.96294 12.5919C5.8299 12.7795 5.75889 13.0001 5.75889 13.2258C5.75889 13.5284 5.88645 13.8186 6.11351 14.0325C6.34056 14.2465 6.64851 14.3667 6.96961 14.3667ZM21.4983 2.9572H20.2875V1.81624C20.2875 1.51365 20.16 1.22344 19.9329 1.00947C19.7059 0.7955 19.3979 0.675293 19.0768 0.675293C18.7557 0.675293 18.4478 0.7955 18.2207 1.00947C17.9937 1.22344 17.8661 1.51365 17.8661 1.81624V2.9572H8.18033V1.81624C8.18033 1.51365 8.05278 1.22344 7.82572 1.00947C7.59867 0.7955 7.29072 0.675293 6.96961 0.675293C6.64851 0.675293 6.34056 0.7955 6.11351 1.00947C5.88645 1.22344 5.75889 1.51365 5.75889 1.81624V2.9572H4.54818C3.58487 2.9572 2.66101 3.31782 1.97985 3.95973C1.29869 4.60164 0.916016 5.47226 0.916016 6.38005V20.0715C0.916016 20.9793 1.29869 21.8499 1.97985 22.4918C2.66101 23.1337 3.58487 23.4943 4.54818 23.4943H21.4983C22.4616 23.4943 23.3854 23.1337 24.0666 22.4918C24.7477 21.8499 25.1304 20.9793 25.1304 20.0715V6.38005C25.1304 5.47226 24.7477 4.60164 24.0666 3.95973C23.3854 3.31782 22.4616 2.9572 21.4983 2.9572ZM22.709 20.0715C22.709 20.3741 22.5814 20.6643 22.3544 20.8783C22.1273 21.0922 21.8194 21.2124 21.4983 21.2124H4.54818C4.22707 21.2124 3.91912 21.0922 3.69207 20.8783C3.46501 20.6643 3.33746 20.3741 3.33746 20.0715V9.80291H22.709V20.0715ZM22.709 7.521H3.33746V6.38005C3.33746 6.07745 3.46501 5.78725 3.69207 5.57328C3.91912 5.35931 4.22707 5.2391 4.54818 5.2391H21.4983C21.8194 5.2391 22.1273 5.35931 22.3544 5.57328C22.5814 5.78725 22.709 6.07745 22.709 6.38005V7.521ZM6.96961 18.9305C7.20907 18.9305 7.44315 18.8636 7.64225 18.7382C7.84136 18.6129 7.99654 18.4347 8.08817 18.2262C8.17981 18.0177 8.20379 17.7883 8.15707 17.567C8.11036 17.3457 7.99504 17.1424 7.82572 16.9828C7.6564 16.8232 7.44067 16.7146 7.20581 16.6705C6.97096 16.6265 6.72752 16.6491 6.50629 16.7355C6.28506 16.8218 6.09597 16.9681 5.96294 17.1557C5.8299 17.3433 5.75889 17.5639 5.75889 17.7896C5.75889 18.0922 5.88645 18.3824 6.11351 18.5963C6.34056 18.8103 6.64851 18.9305 6.96961 18.9305Z"
                            fill="white" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <a class="cs-color2 pl-3 py-1 mb-1 mt-0" href="/users">View more</a>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-show="isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="22%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="8"></v-col>
                  <b-skeleton no-aspect height="70px" width="11%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="" style="padding: 9.5px 8px 2px 8px !important;">
                  <v-row class=" pl-6 pr-4 py-1 mb-1 mt-0" style="padding-top: 0.3rem; padding-bottom:0.3rem;">
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="12" v-show="!isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="10">
                    <v-card-subtitle class="cs-color font-weight-bold pl-5 pt-3 pb-0">Short Term Followup</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.short_term }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="2" class="mt-2">
                    <v-btn x-large fab dark color="green accent-4" class="gradient3 elevation-0 ml-3 d-icon"
                           style="cursor: default">
                      <!-- <v-icon size="24px" class="fa fa-user-o"></v-icon> -->
                      <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.7259 14.88V17.2152C10.7147 16.8576 9.63239 16.748 8.56996 16.8954C7.50753 17.0428 6.49599 17.443 5.62027 18.0623C4.74454 18.6817 4.03022 19.5021 3.53728 20.4547C3.04434 21.4074 2.78717 22.4644 2.78738 23.537L0.552735 23.5359C0.552388 22.1715 0.864379 20.8251 1.4648 19.6C2.06522 18.3748 2.93814 17.3034 4.01667 16.4677C5.0952 15.6321 6.35071 15.0544 7.687 14.779C9.02329 14.5036 10.4049 14.5378 11.7259 14.8789V14.88ZM9.4913 13.4811C5.78738 13.4811 2.78738 10.4811 2.78738 6.77716C2.78738 3.07325 5.78738 0.0732422 9.4913 0.0732422C13.1952 0.0732422 16.1952 3.07325 16.1952 6.77716C16.1952 10.4811 13.1952 13.4811 9.4913 13.4811ZM9.4913 11.2464C11.9606 11.2464 13.9606 9.24644 13.9606 6.77716C13.9606 4.30789 11.9606 2.30788 9.4913 2.30788C7.02202 2.30788 5.02202 4.30789 5.02202 6.77716C5.02202 9.24644 7.02202 11.2464 9.4913 11.2464ZM15.9639 21.2062L19.9137 17.2565L21.4947 18.8364L15.9639 24.3671L12.0131 20.4163L13.5941 18.8364L15.9628 21.2062H15.9639Z"
                            fill="white" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class="counter-row">
                    <v-col cols="3" class="col-wide text-right">
                      <span class="cs-color pr-3 counter-text">Highly Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                          dashboard.sh_interested }}</v-btn>
                    </v-col>
                    <v-col cols="3" class="col-narrow text-right">
                      <span class="cs-color pr-3 counter-text"> Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                          dashboard.s_interested }}</v-btn>
                    </v-col>
                    <v-col cols="4" class="col-wide text-center">
                  <span class="cs-color pr-3 counter-text">
                    Less Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                          dashboard.sl_interested }}</v-btn>
                    </v-col>
                    <v-col cols="2" class="col-narrow">
                      <span class="cs-color pr-3 counter-text"> Others</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                          dashboard.sl_other }}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" v-show="(role == 0 || role == 1) && isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row style="padding:1.5rem 2rem;">
                  <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
                  <b-skeleton-img no-aspect height="15px" width="22%"  border-radius="5%"></b-skeleton-img>
                  <v-col cols="8"></v-col>
                  <b-skeleton no-aspect height="70px" width="11%"  type="avatar" ></b-skeleton>
                  <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="" style="padding: 9.5px 8px 2px 8px !important;">
                  <v-row class=" pl-6 pr-4 py-1 mb-1 mt-0" style="padding-top: 0.3rem; padding-bottom:0.3rem;">
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                    <v-col cols="3" style="display: flex;padding: 0px !important;">
                      <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                      <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
            <v-col cols="12" v-show="(role == 0 || role == 1) && !isLoader">
              <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
                <v-row>
                  <v-col cols="10">
                    <v-card-subtitle class="cs-color font-weight-bold pl-5 pt-3 pb-0">Long Term Followup</v-card-subtitle>
                    <v-card-text style="font-family: Mulish, sans-serif !important"
                                 class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.long_term }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="2" class="mt-2">
                    <v-btn x-large fab dark class="gradient6 elevation-0 ml-3 d-icon" style="cursor: default">
                      <!-- <v-icon size="28px">mdi-account</v-icon> -->
                      <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.7259 15.1095V17.4447C10.7147 17.0871 9.63239 16.9775 8.56996 17.1249C7.50753 17.2723 6.49599 17.6725 5.62027 18.2918C4.74454 18.9112 4.03022 19.7316 3.53728 20.6842C3.04434 21.6369 2.78717 22.6939 2.78738 23.7665L0.552735 23.7653C0.552388 22.401 0.864379 21.0546 1.4648 19.8295C2.06522 18.6043 2.93814 17.5329 4.01667 16.6972C5.0952 15.8616 6.35071 15.2839 7.687 15.0085C9.02329 14.7331 10.4049 14.7673 11.7259 15.1083V15.1095ZM9.4913 13.7106C5.78738 13.7106 2.78738 10.7106 2.78738 7.00666C2.78738 3.30274 5.78738 0.302734 9.4913 0.302734C13.1952 0.302734 16.1952 3.30274 16.1952 7.00666C16.1952 10.7106 13.1952 13.7106 9.4913 13.7106ZM9.4913 11.4759C11.9606 11.4759 13.9606 9.47593 13.9606 7.00666C13.9606 4.53738 11.9606 2.53738 9.4913 2.53738C7.02202 2.53738 5.02202 4.53738 5.02202 7.00666C5.02202 9.47593 7.02202 11.4759 9.4913 11.4759ZM15.9639 21.4357L19.9137 17.486L21.4947 19.0659L15.9639 24.5966L12.0131 20.6458L13.5941 19.0659L15.9628 21.4357H15.9639Z"
                            fill="white" />
                      </svg>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="mb-0" />
                <v-card-actions class="">
                  <v-row class="counter-row">
                    <v-col cols="3" class="col-wide text-right">
                      <span class="cs-color pr-3 counter-text">Highly Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon circles"
                             style="cursor: default">{{ dashboard.h_interested }}</v-btn>
                    </v-col>
                    <v-col cols="3" class="col-narrow text-right">
                      <span class="cs-color pr-3 counter-text"> Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon"
                             style="cursor: default">{{ dashboard.interested }}</v-btn>
                    </v-col>
                    <v-col cols="4" class="col-wide text-center">
                  <span class="cs-color pr-3 counter-text">
                    Less Interested</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon"
                             style="cursor: default">{{ dashboard.l_interested }}</v-btn>
                    </v-col>
                    <v-col cols="2" class="col-narrow">
                      <span class="cs-color pr-3 counter-text"> Others</span>
                      <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon"
                             style="cursor: default">{{ dashboard.l_other }}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

      </v-row>


      <!-- For CRM -->
      <v-row class="mt-2" v-if="role == 2 || role == 6">
        <v-col cols="6" v-show="isLoader">
          <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
            <v-row style="padding:1.5rem 2rem;">
              <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
              <b-skeleton-img no-aspect height="15px" width="22%"  border-radius="5%"></b-skeleton-img>
              <v-col cols="8"></v-col>
              <b-skeleton no-aspect height="70px" width="11%"  type="avatar" ></b-skeleton>
              <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
            </v-row> 
            <v-divider class="mb-0" />
            <v-card-actions class="" style="padding: 9.5px 8px 2px 8px !important;">
              <v-row class=" pl-6 pr-4 py-1 mb-1 mt-0" style="padding-top: 0.3rem; padding-bottom:0.3rem;">
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
              </v-row>
            </v-card-actions>
          
          </v-card>
        </v-col>
        <v-col cols="6" v-show="!isLoader">
          <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
            <v-row>
              <v-col cols="10">
                <v-card-subtitle class="cs-color font-weight-bold pl-5 pt-3 pb-0">Short Term Followup</v-card-subtitle>
                <v-card-text style="font-family: Mulish, sans-serif !important"
                  class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.short_term }}
                </v-card-text>
              </v-col>
              <v-col cols="2" class="mt-2">
                <v-btn x-large fab dark color="green accent-4" class="gradient3 elevation-0 ml-3 d-icon"
                  style="cursor: default">
                  <!-- <v-icon size="24px" class="fa fa-user-o"></v-icon> -->
                  <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.7259 14.88V17.2152C10.7147 16.8576 9.63239 16.748 8.56996 16.8954C7.50753 17.0428 6.49599 17.443 5.62027 18.0623C4.74454 18.6817 4.03022 19.5021 3.53728 20.4547C3.04434 21.4074 2.78717 22.4644 2.78738 23.537L0.552735 23.5359C0.552388 22.1715 0.864379 20.8251 1.4648 19.6C2.06522 18.3748 2.93814 17.3034 4.01667 16.4677C5.0952 15.6321 6.35071 15.0544 7.687 14.779C9.02329 14.5036 10.4049 14.5378 11.7259 14.8789V14.88ZM9.4913 13.4811C5.78738 13.4811 2.78738 10.4811 2.78738 6.77716C2.78738 3.07325 5.78738 0.0732422 9.4913 0.0732422C13.1952 0.0732422 16.1952 3.07325 16.1952 6.77716C16.1952 10.4811 13.1952 13.4811 9.4913 13.4811ZM9.4913 11.2464C11.9606 11.2464 13.9606 9.24644 13.9606 6.77716C13.9606 4.30789 11.9606 2.30788 9.4913 2.30788C7.02202 2.30788 5.02202 4.30789 5.02202 6.77716C5.02202 9.24644 7.02202 11.2464 9.4913 11.2464ZM15.9639 21.2062L19.9137 17.2565L21.4947 18.8364L15.9639 24.3671L12.0131 20.4163L13.5941 18.8364L15.9628 21.2062H15.9639Z"
                      fill="white" />
                  </svg>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mb-0" />
            <v-card-actions class="">
              <v-row class="counter-row">
                <v-col cols="3" class="col-wide text-right">
                  <span class="cs-color pr-3 counter-text">Highly Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.sh_interested }}</v-btn>
                </v-col>
                <v-col cols="3" class="col-narrow text-right">
                  <span class="cs-color pr-3 counter-text"> Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.s_interested }}</v-btn>
                </v-col>
                <v-col cols="4" class="col-wide text-center">
                  <span class="cs-color pr-3 counter-text">
                    Less Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.sl_interested }}</v-btn>
                </v-col>
                <v-col cols="2" class="col-narrow">
                  <span class="cs-color pr-3 counter-text"> Others</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.sl_other }}</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6" v-show="isLoader">
          <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
            <v-row style="padding:1.5rem 2rem;">
              <!-- <v-col cols="5" class="skeleton col-narrow" style="height:5px"></v-col> -->
              <b-skeleton-img no-aspect height="15px" width="22%"  border-radius="5%"></b-skeleton-img>
              <v-col cols="8"></v-col>
              <b-skeleton no-aspect height="70px" width="11%"  type="avatar" ></b-skeleton>
              <v-col cols="1" class="skeleton skeleton-text" style="margin-top: -50px;height: 35px;"></v-col>
            </v-row> 
            <v-divider class="mb-0" />
            <v-card-actions class="" style="padding: 9.5px 8px 2px 8px !important;">
              <v-row class=" pl-6 pr-4 py-1 mb-1 mt-0" style="padding-top: 0.3rem; padding-bottom:0.3rem;">
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
                <v-col cols="3" style="display: flex;padding: 0px !important;">
                  <b-skeleton-img  no-aspect  height="20px" width="70%"  border-radius="5%"></b-skeleton-img>
                  <b-skeleton no-aspect type="avatar" class="white--text font-weight-bold counter-icon circles v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small" style=" margin-top: -6px;margin-left: 12px; padding-top: 28px;"></b-skeleton>
                </v-col> 
              </v-row>
            </v-card-actions>
          
          </v-card>
        </v-col>
        <v-col cols="6" v-show="!isLoader">
          <v-card class="rounded-lg pl-1" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16)">
            <v-row>
              <v-col cols="10">
                <v-card-subtitle class="cs-color font-weight-bold pl-5 pt-3 pb-0">Long Term Followup</v-card-subtitle>
                <v-card-text style="font-family: Mulish, sans-serif !important"
                  class="stats color-default display-1 font-weight-bold pl-5 pt-0 pb-5">{{ dashboard.long_term }}
                </v-card-text>
              </v-col>
              <v-col cols="2" class="mt-2">
                <v-btn x-large fab dark class="gradient6 elevation-0 ml-3 d-icon" style="cursor: default">
                  <!-- <v-icon size="28px">mdi-account</v-icon> -->
                  <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.7259 15.1095V17.4447C10.7147 17.0871 9.63239 16.9775 8.56996 17.1249C7.50753 17.2723 6.49599 17.6725 5.62027 18.2918C4.74454 18.9112 4.03022 19.7316 3.53728 20.6842C3.04434 21.6369 2.78717 22.6939 2.78738 23.7665L0.552735 23.7653C0.552388 22.401 0.864379 21.0546 1.4648 19.8295C2.06522 18.6043 2.93814 17.5329 4.01667 16.6972C5.0952 15.8616 6.35071 15.2839 7.687 15.0085C9.02329 14.7331 10.4049 14.7673 11.7259 15.1083V15.1095ZM9.4913 13.7106C5.78738 13.7106 2.78738 10.7106 2.78738 7.00666C2.78738 3.30274 5.78738 0.302734 9.4913 0.302734C13.1952 0.302734 16.1952 3.30274 16.1952 7.00666C16.1952 10.7106 13.1952 13.7106 9.4913 13.7106ZM9.4913 11.4759C11.9606 11.4759 13.9606 9.47593 13.9606 7.00666C13.9606 4.53738 11.9606 2.53738 9.4913 2.53738C7.02202 2.53738 5.02202 4.53738 5.02202 7.00666C5.02202 9.47593 7.02202 11.4759 9.4913 11.4759ZM15.9639 21.4357L19.9137 17.486L21.4947 19.0659L15.9639 24.5966L12.0131 20.6458L13.5941 19.0659L15.9628 21.4357H15.9639Z"
                      fill="white" />
                  </svg>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mb-0" />
            <v-card-actions class="">
              <v-row class="counter-row">
                <v-col cols="3" class="col-wide text-right">
                  <span class="cs-color pr-3 counter-text">Highly Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon circles">{{
                    dashboard.h_interested }}</v-btn>
                </v-col>
                <v-col cols="3" class="col-narrow text-right">
                  <span class="cs-color pr-3 counter-text"> Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.interested }}</v-btn>
                </v-col>
                <v-col cols="4" class="col-wide text-center">
                  <span class="cs-color pr-3 counter-text">
                    Less Interested</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.l_interested }}</v-btn>
                </v-col>
                <v-col cols="2" class="col-narrow">
                  <span class="cs-color pr-3 counter-text"> Others</span>
                  <v-btn depressed fab x-small class="cs-bg-color white--text font-weight-bold counter-icon">{{
                    dashboard.l_other }}</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tables -->
      <v-row>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-col class="color-default font-weight-bold py-5 px-5 mb-1">
              <b-skeleton-img  no-aspect  height="34px" width="40%"  border-radius="5%"></b-skeleton-img>
            </v-col>
            <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead id="support_table_header">
                <tr>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                </tr>
              </thead>
              <tbody id="table_body">
                <tr  id="table_row" >
                  <td colspan="8 ">
                    <b-skeleton-wrapper >
                        <b-skeleton height="40px" ></b-skeleton>   
                        <b-skeleton height="40px"></b-skeleton>  
                        <b-skeleton height="40px"></b-skeleton>                                     
                    </b-skeleton-wrapper> 
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table> -->
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2  || role == 6) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Today's Followups</v-card-title>
            <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table>
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-col class="color-default font-weight-bold py-5 px-5 mb-1">
              <b-skeleton-img  no-aspect  height="34px" width="40%"  border-radius="5%"></b-skeleton-img>
            </v-col>
            <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead id="support_table_header">
                <tr>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                </tr>
              </thead>
              <tbody id="table_body">
                <tr  id="table_row" >
                  <td colspan="8 ">
                    <b-skeleton-wrapper >
                        <b-skeleton height="40px" ></b-skeleton>   
                        <b-skeleton height="40px"></b-skeleton>  
                        <b-skeleton height="40px"></b-skeleton>                                     
                    </b-skeleton-wrapper> 
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table> -->
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Today's Demo</v-card-title>
            <demo-requests-table :demoRequests="dashboard.daily_demo" :totalPages="dashboard.totalPages2"
              :page="dashboard.page" :total_demo="dashboard.total_todays_demos" :totalRows="dashboard.totalRows2" :demo_flag="dashboard.demo_flag"
              @setPage="setPage2">
            </demo-requests-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-col class="color-default font-weight-bold py-5 px-5 mb-1">
              <b-skeleton-img  no-aspect  height="34px" width="40%"  border-radius="5%"></b-skeleton-img>
            </v-col>
            <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead id="support_table_header">
                <tr>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                </tr>
              </thead>
              <tbody id="table_body">
                <tr  id="table_row" >
                  <td colspan="8 ">
                    <b-skeleton-wrapper >
                        <b-skeleton height="40px" ></b-skeleton>   
                        <b-skeleton height="40px"></b-skeleton>  
                        <b-skeleton height="40px"></b-skeleton>                                     
                    </b-skeleton-wrapper> 
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table> -->
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Missed Followups</v-card-title>
            <demo-requests-table :demoRequests="dashboard.missed_follow_up" :page="dashboard.page"
              :totalPages="dashboard.totalPages" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total" :totalRows="dashboard.totalRows" @setPage="setPage">
            </demo-requests-table>
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-col class="color-default font-weight-bold py-5 px-5 mb-1">
              <b-skeleton-img  no-aspect  height="34px" width="40%"  border-radius="5%"></b-skeleton-img>
            </v-col>
            <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
              <thead id="support_table_header">
                <tr>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                  <th style="padding: 9px 0.75rem;"> <b-skeleton height="20px" ></b-skeleton>   </th>
                </tr>
              </thead>
              <tbody id="table_body">
                <tr  id="table_row" >
                  <td colspan="8 ">
                    <b-skeleton-wrapper >
                        <b-skeleton height="40px" ></b-skeleton>   
                        <b-skeleton height="40px"></b-skeleton>  
                        <b-skeleton height="40px"></b-skeleton>                                     
                    </b-skeleton-wrapper> 
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <demo-requests-table :demoRequests="dashboard.daily_follow_up" :totalPages="dashboard.totalPages1"
              :page="dashboard.page" :flag="dashboard.flag" :temp="dashboard.temp"
              :total_demo="dashboard.total_todays_followups" :totalRows="dashboard.totalRows1" @setPage="setPage1">
            </demo-requests-table> -->
          </v-card>
        </v-col>
        <v-col cols="6" v-show="(role == 0 || role == 1 || role == 2 || role == 6) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Not Logged Organizations</v-card-title>
            <not-logged-ord-table :demoRequests="dashboard.not_logged_orgs" :totalPages="dashboard.totalPages3"
              :page="dashboard.page" :demo_flag="dashboard.demo_flag" :total="dashboard.total_not_logged_orgs" :totalRows="dashboard.totalRows3" @setPage="setPage3">
            </not-logged-ord-table>
          </v-card>
        </v-col>

        <!-- for show the zoom call history -->
        <v-col cols="6" v-show="(role == 0 || role == 1) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Zoom Call History</v-card-title>
            <zoom-call-history-table :zoomCallHistory="dashboard.zoom_call_logs" :flag="dashboard.flag" :total="dashboard.total4"
            :totalPages="dashboard.totalPages4" :page="dashboard.page4"  :totalRows="dashboard.totalRows4" :currentPage="dashboard.currentPage4"
             @setPage="setPage4" @dateFilter="dateFilter" @userFilter="userFilter"  :user="dashboard.filter_user">
            </zoom-call-history-table>
          </v-card>
        </v-col>
        <!-- for show the zoom call history -->
        <!-- for customer show max call -->
        <v-col cols="6" v-show="(role == 1) && !isLoader">
          <v-card class="rounded-lg" style="
              box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
              min-height: 510px;
              height: auto;
            ">
            <v-card-title class="color-default font-weight-bold py-5 px-5 mb-1">Top Dialers</v-card-title>
            <support-user-call-record :supportUser="dashboard.support_users" >
            </support-user-call-record>
          </v-card>
        </v-col>
        <!-- customer show maxcall -->

      </v-row>
    </div>
  </v-app>
</template>
<script>
  import DemoRequestsTable from "./users/demo_requests_table.vue";
  import NotLoggedOrdTable from "./users/not_logged_org_table.vue";
  import ZoomCallHistoryTable from "./users/zoom_call_history_table.vue";
  import SupportUserCallRecord from "./users/support_user_call_record_table.vue";



  import { mapState } from 'vuex';
  import QuickView from "@/components/tasks/quickView.vue";
  import Quick_task from "@/components/users/quick_task.vue";
  import axios from "axios";
  export default {
    components: {
      Quick_task,
      QuickView,
      DemoRequestsTable,
      NotLoggedOrdTable,
      ZoomCallHistoryTable,
      SupportUserCallRecord
    },
    data: function () {
      return {
        role: "",
        product: 0,
        ABC:0,
        dashboard: {
          totalRows:0,
          totalRows1:0,
          totalRows2: 0,
          total_users: 0,
          posts: 0,
          tasks:0,
          comments: 0,
          users: 0,
          h_interested: 0,
          interested: 0,
          l_interested: 0,
          l_other: 0,
          sh_interested: 0,
          s_interested: 0,
          sl_interested: 0,
          sl_other: 0,
          short_term: 0,
          leng_term: 0,
          views: 0,
          follow_up: 0,
          next_week: 0,
          daily_follow_up: "",
          daily_demo: "",
          missed_follow_up: "",
          currentPage: 0,
          currentPage1: 0,
          totalPages1: 0,
          currentPage2: 0,
          totalPages2: 0,
          totalPages: 0,
          page: 1,
          total: 0,
          total_todays_followups: 0,
          total_todays_demos: 0,
          flag: true,
          demo_flag: true,
          temp: true,
          isLoader: true,
          totalRows3: 0,
          not_logged_orgs: "",
          zoom_call_logs:"",
          zoom_call_history: "",
          currentPage3: 0,
          totalPages3: 0,
          total_not_logged_orgs: 0,
          totalRows4: 0,
          pageQuickTask: 1,
          currentPage4: 0,
          currentPageQuickTask: 0,
          totalPageQuickTask: 0,
          totalQuickTask: 0,
          totalRowsQuickTask: 0,

          totalPages4: 0,
          total4:0,
          page4:1,
          support_users:'',
           totalRows5: 0,
          currentPage5: 0,
          totalPages5: 0,
          total5:0,
          page5:1,
          filter_user:'',
          quickTaskList: []

        },
      };
    },
    computed:{
        ...mapState('users', ['selectedProduct']), 
    },
    watch: {
        selectedProduct (newProduct) {
          this.fetchCompanyData(newProduct);
           this.product = localStorage.getItem('product');
        }
    },
    created: function () {
      this.product = localStorage.getItem('product');
      this.fetchCompanyData(this.product);
      this.role = JSON.parse(localStorage.getItem("role"));
    },
    mounted : function(){
      if( this.$route.fullPath == '/dashboard'){
        //  this.$el.querySelector(".table").style.overflow =  '0.75rem 0.75rem';
        //  this.$el.querySelector(".table tr td").style.transform= 'translate3d(568%, 9%, 0px)';
         this.$el.querySelector("table tr td:nth-child(1)").style.width =  '30%';
        //  this.$el.querySelector("table tr td:nth-child(1)").style.paddingLeft =  '1rem';
         this.$el.querySelector("table tr td:nth-child(2)").style.width =  '30%';
         this.$el.querySelector("table tr td:nth-child(3)").style.width =  '30%';
         this.$el.querySelector("table tr td:nth-child(4)").style.width =  '30%';
         this.$el.q
       }
    },
    methods: { 
      fetchCompanyData(product){
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.$refs.formContainer,
        // });
        this.isLoader = true;
        this.axios.get("/admin/dashboard?page=" + this.dashboard.page + "&product=" + product).then((response) => {
          let data = response.data;
          this.dashboard.short_term = data.short_term.short_term.total;
          this.dashboard.long_term = data.long_term.long_term.total;
          this.dashboard.h_interested = data.long_term.long_term.highly_interested;
          this.dashboard.interested = data.long_term.long_term.interested;
          this.dashboard.l_interested = data.long_term.long_term.less_interested;
          this.dashboard.l_other = this.dashboard.long_term - (this.dashboard.h_interested + this.dashboard.l_interested + this.dashboard.interested);    
          this.dashboard.sh_interested = data.short_term.short_term.highly_interested;
          this.dashboard.s_interested = data.short_term.short_term.interested;
          this.dashboard.sl_interested = data.short_term.short_term.less_interested;
          this.dashboard.sl_other = this.dashboard.short_term - (this.dashboard.sh_interested + this.dashboard.sl_interested + this.dashboard.s_interested);
          this.dashboard.posts = data.posts;
          this.dashboard.comments = data.comments;
          this.dashboard.tasks = data.tasks;
          this.dashboard.users = data.users;
          this.dashboard.views = data.views;
          // this.dashboard.next_week = data.next_week;

          //remove fetchAllTask function call because we already have this data
          //this.fetchAllTask(this.dashboard.page, product);
          this.dashboard.quickTaskList = data.quick_task_list.data;
          this.dashboard.currentPageQuickTask = this.dashboard.page;
          this.dashboard.totalQuickTask = data.quick_task_list.total;
          this.dashboard.totalRowsQuickTask = data.quick_task_list.totalRows;
          this.dashboard.totalPageQuickTask = Math.ceil(data.quick_task_list.total / 5);
          this.dashboard.flag = false;

          if(this.role == 1){
            //remove getSupportUserRecord function call because we already have this data
            // this.getSupportUserRecord(this.dashboard.page, product);
            this.dashboard.support_users = data.support_users.data;
            this.dashboard.currentPage5 = this.dashboard.page;
            this.dashboard.total5 = data.support_users.total;
            this.dashboard.totalRows5 = data.support_users.totalRows;
            this.dashboard.totalPages5 = Math.ceil(data.support_users.total / 5);
            this.dashboard.flag = true;
          }


          if(this.role == 0 || this.role == 1){
            //remove getZoomCallLogs function call because we already have this data
            //this.getZoomCallLogs(this.dashboard.page, product);
            this.dashboard.zoom_call_logs = data.zoom_call_logs.data;
            this.dashboard.filter_user = data.support_users.array_data;
            this.dashboard.currentPage4 = this.dashboard.page;
            this.dashboard.total4 = data.zoom_call_logs.total;
            this.dashboard.totalRows4 = data.zoom_call_logs.totalRows;
            this.dashboard.totalPages4 = Math.ceil(data.zoom_call_logs.total / 5);

          }
          if(this.role == 0 || this.role == 1 || this.role == 2 || this.role == 6){
            //remove getDailyDemo ,getDailyFollowup,getMissedFollowup,getNotLoggedOrganizations function call because we already have this data
            // this.getDailyDemo(this.dashboard.page, product);
            this.dashboard.daily_demo = data.daily_demo.data;
            this.dashboard.currentPage2 = this.dashboard.page;
            this.dashboard.totalRows2 = data.daily_demo.totalRows;
            this.dashboard.total_todays_demos = data.daily_demo.total;
            this.dashboard.totalPages2 = Math.ceil(data.daily_demo.total / 5);
            this.dashboard.demo_flag = true;

            //this.getDailyFollowup(this.dashboard.page, product);
            this.dashboard.daily_follow_up = data.daily_follow_up.data;
            this.dashboard.currentPage1 = this.dashboard.page;
            this.dashboard.totalRows1 = data.daily_follow_up.totalRows;
            this.dashboard.total_todays_followups = data.daily_follow_up.total;
            this.dashboard.totalPages1 = Math.ceil(data.daily_follow_up.total / 5);

            //this.getMissedFollowup(this.dashboard.page, product);
            this.dashboard.missed_follow_up = data.missed_follow_up.data;
            this.dashboard.currentPage = this.dashboard.page;
            this.dashboard.total = data.missed_follow_up.total;
            this.dashboard.totalRows = data.missed_follow_up.totalRows;
            this.dashboard.totalPages = Math.ceil(data.missed_follow_up.total / 5);



            // this.getNotLoggedOrganizations(this.dashboard.page, product);
            console.log('sdfsdsdf sdfsdfsd');
            console.log(data.not_logged_orgs.total);
            this.dashboard.not_logged_orgs = data.not_logged_orgs.data;
            this.dashboard.currentPage3 = this.dashboard.page;
            this.dashboard.total_not_logged_orgs = data.not_logged_orgs.total;
            this.dashboard.totalRows3 = data.not_logged_orgs.totalRows;
            this.dashboard.totalPages3 = Math.ceil(data.not_logged_orgs.total / 5);
          }
          this.dashboard.flag = false;
          this.isLoader = false;
        });
        // .then(()=>{
        //   // loader.hide();
        //   // setTimeout(() => {
        //     this.isLoader = false;
        //   // }, 400);
        //
        // });
      },
      getDailyFollowup(page, product) {
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product).then((response) => {
          let res = response.data.daily_follow_up;
          this.dashboard.daily_follow_up = res.data;
          this.dashboard.currentPage1 = page;
          this.dashboard.totalRows1 = res.totalRows;
          this.dashboard.total_todays_followups = res.total;
          this.dashboard.totalPages1 = Math.ceil(res.total / 5);
          this.dashboard.flag = false;
        });
      },
      getDailyDemo(page, product) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.$refs.formContainer,
        // });
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product).then((response) => {
          let res = response.data.daily_demo;
          this.dashboard.daily_demo = res.data;
          this.dashboard.currentPage2 = page;
          this.dashboard.totalRows2 = res.totalRows;
          this.dashboard.total_todays_demos = res.total;
          this.dashboard.totalPages2 = Math.ceil(res.total / 5);
          this.dashboard.demo_flag = true;
          // loader.hide();
        });
      },
      getMissedFollowup(page, product) {
        //  let loader = this.$loading.show({
        //   loader: "dots",
        //   container:  this.$refs.formContainer,
        // });
        
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product).then((response) => {
          let res = response.data.missed_follow_up;
          this.dashboard.missed_follow_up = res.data;
          this.dashboard.currentPage = page;
          this.dashboard.total = res.total;
          this.dashboard.totalRows = res.totalRows;
          this.dashboard.totalPages = Math.ceil(res.total / 5);
          // loader.hide();
          this.dashboard.flag = false;
        });
      },
      getZoomCallLogs(page='', product,start_date='',end_date='',user_name='') {
        //  let loader = this.$loading.show({
        //   loader: "dots",
        //   container:  this.$refs.formContainer,
        // });
        
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product + "&start_date="+start_date+ "&end_date="+end_date+'&user_name='+user_name).then((response) => {
          let res = response;
          this.dashboard.zoom_call_logs = res.data.zoom_call_logs.data;
          this.dashboard.filter_user = res.data.support_users.array_data;
          this.dashboard.currentPage4 = page;
          this.dashboard.total4 = res.data.zoom_call_logs.total;
          this.dashboard.totalRows4 = res.data.zoom_call_logs.totalRows;
          this.dashboard.totalPages4 = Math.ceil(res.data.zoom_call_logs.total / 5);
          // loader.hide();
          this.dashboard.flag = false;
        });
      },
      getSupportUserRecord(page, product) {
        //  let loader = this.$loading.show({
        //   loader: "dots",
        //   container:  this.$refs.formContainer,
        // });
        
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product).then((response) => {
          let res = response;
          this.dashboard.support_users = res.data.support_users.data;
          this.dashboard.currentPage5 = page;
          this.dashboard.total5 = res.data.support_users.total;
          this.dashboard.totalRows5 = res.data.support_users.totalRows;
          this.dashboard.totalPages5 = Math.ceil(res.data.support_users.total / 5);
          // loader.hide();
          this.dashboard.flag = true;
        });
      },
      getNotLoggedOrganizations(page, product) {
        this.axios.get("/admin/dashboard?page=" + page + "&product=" + product).then((response) => {
          let res = response.data.not_logged_orgs;
          this.dashboard.not_logged_orgs = res.data;
          this.dashboard.currentPage3 = page;
          this.dashboard.total_not_logged_orgs = res.total;
          this.dashboard.totalRows3 = res.totalRows;
          this.dashboard.totalPages3 = Math.ceil(res.total / 5);
          // loader.hide();
          this.dashboard.flag = false;
        });
      },
      // getZoomCallHistory(page, product) {
      //   this.axios.get("/admin/zoom-call-history").then((response) => {
      //     let res = response.data;
      //     this.dashboard.zoom_call_history = res.data.call_logs;
      //     this.dashboard.flag = false;
      //   });
      // },

      fetchAllTask(page, product) {
        let params = `?page=${page}&product=${product}`;
        this.axios.get(`/admin/dashboard${params}`).then((response) => {
          this.dashboard.quickTaskList = response.data.quick_task_list.data;
          this.dashboard.currentPageQuickTask = page;
          this.dashboard.totalQuickTask = response.data.quick_task_list.total;
          this.dashboard.totalRowsQuickTask = response.data.quick_task_list.totalRows;
          this.dashboard.totalPageQuickTask = Math.ceil(response.data.quick_task_list.total / 5);
          this.dashboard.flag = false;
        });
      },


      setPage(page) {
        console.log(page);
         this.dashboard.page = page;
        this.getMissedFollowup(this.dashboard.page, this.product);
      },
      setPage1(page) {
         this.dashboard.page = page;
        this.getDailyFollowup(this.dashboard.page, this.product);
      },
      setPage2(page) {
        this.dashboard.page = page;
        this.getDailyDemo(this.dashboard.page, this.product);
      },
      setPage3(page) {
        this.dashboard.page = page;
        this.getNotLoggedOrganizations(this.dashboard.page, this.product);
      },
        setPage4(page,start_date='',end_date='',user_name='') {
        this.dashboard.page4 = page;
        this.getZoomCallLogs(this.dashboard.page4, this.product,start_date,end_date,user_name);
      },
        dateFilter(start_date,end_date,user_name) {
         this.getZoomCallLogs(1, this.product,start_date,end_date,user_name);
      },
        userFilter(user_name='',start_date,end_date) {
        this.getZoomCallLogs('', this.product,start_date,end_date,user_name);
       },


      setPageQuickTask(page) {
        console.log("page number", page)
        this.dashboard.pageQuickTask = page;
        this.fetchAllTask(this.dashboard.pageQuickTask, this.product);
        this.setPage(page);
      },

      setStatus(value){
        this.fetchAllTask(this.dashboard.page,this.product,'','',value,'')
      }
    },
  };
</script>
<style>
.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 80%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
}

.skeleton-text {
  width: 100%;
  height: 0.7rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
}
/* 
.skeleton-text__body {
  width: 75%;
}

.skeleton-footer {
  width: 30%;
} */
  .v-application ul {
    padding: 6px 0;
     
     
  }
  .v-application a {
    color: #48a6a6;
  }
  .v-application ul a {
    padding-left: 12px;
    color: black;
  }

  .custom-table-height {
    height: 320px;
    background-color: white;
  }

  .padding-0 {
    padding: top 0px;
  }

  .card-height {
    height: 300px;
  }

  .cs-color {
    color: #575962 !important;
    font-size: 14px;
  }

  .cs-color2 {
    color: #48a6a6 !important;
    font-size: 14px;
  }

  .cs-bg-color {
    background-color: #b7b7b7 !important;
  }

  .gradient1 {
    background-image: linear-gradient(#3f59b1, #152f79);
  }

  .gradient2 {
    background-image: linear-gradient(#aa04c5, #223886);
  }

  .gradient3 {
    background-image: linear-gradient(#20cc7d, #099756);
  }

  .gradient4 {
    background-image: linear-gradient(#ffcd1b, #ff881b);
  }

  .gradient5 {
    background-image: linear-gradient(#f85a96, #8741a1);
  }

  .gradient6 {
    background-image: linear-gradient(#e95a42, #861d0b);
  }

  .custom-shadow {
    box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);
  }

  .v-card__actions a:hover {
    background-color: #f4f8fa !important;
    padding-right: 12px;
    border-radius: 4px;
  }

  @media only screen and (min-width: 1280px) and (max-width: 1724px) {
    .d-icon {
      right: 40% !important;
      width: 53px !important;
      height: 53px !important;
    }

    .card-title {
      font-size: 13px;
    }

    .test {
      /* color: red !important; */
    }

    .col-wide {
      padding-right: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
    }

    .col-narrow {
      padding-right: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
    }

    .counter-text {
      font-size: 11px !important;
      padding-right: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
    }

    .counter-icon {
      height: 24px !important;
      width: 24px !important;
      padding-right: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
    }

    .counter-row {
      padding-left: 7px;
      padding-top: 3px;
      padding-bottom: 3px;
    }

    .v-card__subtitle {
      font-size: 12px !important;
    }

    .stats {
      font-size: 26px !important;
    }

    .v-card__actions a {
      font-size: 12px !important;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
    }

    .v-card__title {
      font-size: 16px !important;
    }
  }
</style>

<style scoped>

  .lead_table{
    overflow: initial !important;
  }

  
  table tr td:nth-child(1) {
      padding: 0.5rem 1rem !important ;
  }
  
  /* table tr td:nth-child(4) {
   padding: 0.5rem 3rem !important ;
  }  */
/* 
  table tr td:nth-child(2) {
    width: 30% !important;
  } */

  /* table tr td:nth-child(3) {
    width: 25% !important;
  }

  table tr td:nth-child(4) {
    width: 15% !important;
  }      */

  
</style>